import appRoutes from "./app";

const routes = [...appRoutes];

export default routes;
